import { CommonRegularExpressions } from "../../../../../libs/ts/CommonRegularExpressions";
import { ConditionalChoiceNode } from "../../../../../libs/ts/WorkflowTree/Nodes/ConditionalChoiceNode";
import { Model } from "../Model";
import { useChildNodeUndoBehaviour } from "../hooks/useChildNodeUndoBehaviour";
import { BookJobCommunicationsHandler } from "../relationshipHandlers/BookJobCommunicationsHandler";
import { JbpTreeNodeData } from "../treeExtensions/JbpTreeNodeData";
import { FieldType, IMultiButtonsField, IMultiButtonField } from "../treeExtensions/FieldInterfaces";
import { IJbpChildNodeRelationship } from "../treeExtensions/IJbpChildNodeRelationship";

export class ReminderSMSRequiredNode extends ConditionalChoiceNode<JbpTreeNodeData, IJbpChildNodeRelationship> {

    private readonly noButton = {
        button: {
            title: "No",
            modelValueWhenSelected: false
        } as IMultiButtonField,
        enabled: true
    };
    private readonly yesButton = {
        button: {
            title: "Yes",
            modelValueWhenSelected: true
        } as IMultiButtonField,
        enabled: true
    };

    private readonly buttons = [
        this.noButton, this.yesButton
    ]

    public static onYesSelected = () => {
        const prepopulatedValue = Model.GetModel().Get("model.results.siteContactDetails.number");
        if(prepopulatedValue != undefined && CommonRegularExpressions.PhoneNumberRegex.test(prepopulatedValue) == true) {
            Model.GetModel().Set("model.results.confirmationSMSNumber", prepopulatedValue);
        }
    }

    public static onNoSelected = () => {
        Model.GetModel().ClearModelValue("model.results.confirmationSMSNumber");
    }

    public static selectionUpdated = (modelValueToSet: any) => {
        if(modelValueToSet === true) {
            ReminderSMSRequiredNode.onYesSelected();
        } else if(modelValueToSet === false) {
            if(BookJobCommunicationsHandler.shouldOnlyShowSmsInput() == false) {
                ReminderSMSRequiredNode.onNoSelected();
            }
        }
    }

    private readonly field: IMultiButtonsField

    constructor() {

        const childNodeUndoBehaviour = useChildNodeUndoBehaviour();

        const field = {
            fieldType: FieldType.MultiButtons,
            modelPath: "model.results.reminderSMSRequired",
            title: "Do you require an appointment reminder via SMS?",
            hideTitle: true,
            mandatory: true,
            isValid: (title: string) => {
                const isValidRes = title == undefined ? false : true

                return { isValid: isValidRes };
            },
            onChange: (modelValueToSet: any) => {
                ReminderSMSRequiredNode.selectionUpdated(modelValueToSet);
                this.SetChoiceChosen(true);
                childNodeUndoBehaviour.childNodeSelected(this, this);
                if(this.TreeChanged != undefined) {
                    this.TreeChanged();
                }
            },
            buttons: []
        } as IMultiButtonsField

        super("reminderSmsRequired", new JbpTreeNodeData("Do you require an appointment reminder via SMS?", [field]));

        this.field = field;
    }

    public override onInitialise(): void {
        this.field.buttons = this.buttons.filter(b => b.enabled).map(b => b.button);
    }
}
